import axios from 'axios';

export const API_URL = process.env.VUE_APP_SERVER_URL ? process.env.VUE_APP_SERVER_URL : 'https://croinc.bearle.ru';

const api = {

  async registrationRequest(data) {
     return await axios.post(`${API_URL}/api/v1/admin/auth/register/`, data)
  },
  async confirmEmailToken(token){
    return await axios.post(`${API_URL}/api/v1/admin/auth/confirm_email/`, {'token': token});
  },

  setJwtToken(token){
    axios.defaults.headers.common["Authorization"] = "jwt " + token;
  },

}

export default api;
